module.exports = __webpack_public_path__ + "img/img13.a97e0570.svg";